
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mixin as Clickaway} from 'vue-clickaway';
import {SweetModal} from 'sweet-modal-vue';
import TimeZones from '@/modules/TimeZones.vue';
import NevronInput from '../../components/NevronInput.vue';
import {showToaster} from '@/components/DashboardComposer/helpers';
import {translatedDisplayName, translate, bus} from "@/helpers/functions";

@Component({
  components: {
    SweetModal,
    TimeZones,
    NevronInput,
  },
  mixins: [Clickaway],
})
export default class EditWorldClocklocation extends Vue {

  @Prop()
  module!: any;
  @Prop()
  item!: IWorldClockLocation;

  newWorldClockLocation: IWorldClockLocation | null = null;

  mounted() {
    this.setModuleFromProps();
  }

  @Watch('item', {immediate: true})
  setModuleFromProps() {
    this.newWorldClockLocation = JSON.parse(JSON.stringify(this.item));
  }

  timeZoneSelected(zone: string) {
    if (this.newWorldClockLocation) {
      this.newWorldClockLocation.timeZone = zone;
    }
  }

  deleteLocation() {
    if (confirm('Do you really want to delete this Location?')) {
      this.module.deleteItem(this.newWorldClockLocation!.id)
        .then((response: any) => {
          if (!response.success) {
            throw new Error(response.error.message);
          }
          showToaster('success', translate(this.newWorldClockLocation?.city), translate('successfully-deleted'));
          this.$emit('save');
          this.cancel();
        })
        .catch((error: any) => {
          showToaster('danger', '', error);
        });
    }
  }

  save() {
    this.module.updateItem(this.newWorldClockLocation!.id!, this.newWorldClockLocation!)
      .then((response: any) => {
        if (!response.success) {
          throw new Error(response.error.message);
        }
        showToaster('success', translate(this.newWorldClockLocation?.city), translate('successfully-updated'));
        this.$emit('save');
        this.cancel();
      })
      .catch((error: any) => {
        showToaster('danger', '', error);
      });
  }

  cancel(): void {
    // @ts-ignore
    this.$children[0].close();
  }

  openTranslator(localText: any, localKey: any, referenceKey: any) {
    bus().$emit('openTranslator', localText, localKey, referenceKey);
  }

}
